const TYPE_LABELS: Record<ReconciliationRow['type'], string> = {
  capture : 'Einzug',
  refund  : 'Rückerstattung',
  manual  : 'Rückerstattung manuell',
};

const FEE_STATE_LABELS: Record<ReconciliationFeeState, string> = {
  ''       : '',
  open     : 'offen',
  upcoming : 'vorläufig',
  settled  : '',
};

// The captures and refunds of a period (data.php). The page only shows, nothing on it is entered.
export class cAdminReconciliation {

  parent      = document.querySelector('.c-reconciliation')        as HTMLElement;
  script      = document.querySelector('.c-reconciliation script') as HTMLScriptElement;

  div_select  = document.createElement('div');
  div_from    = document.createElement('div');
  label_from  = document.createElement('label');
  input_from  = document.createElement('input');
  div_to      = document.createElement('div');
  label_to    = document.createElement('label');
  input_to    = document.createElement('input');
  a_excel     = document.createElement('a');
  div_error   = document.createElement('div');
  div_fees    = document.createElement('div');
  p_empty     = document.createElement('p');
  div_table   = document.createElement('div');
  table       = document.createElement('table');
  thead       = document.createElement('thead');
  tbody       = document.createElement('tbody');
  h2_sums     = document.createElement('h2');
  div_sums    = document.createElement('div');
  table_sums  = document.createElement('table');
  thead_sums  = document.createElement('thead');
  tbody_sums  = document.createElement('tbody');

  data : ReconciliationData;

  constructor() {

    this.data = JSON.parse(this.script.innerText) as ReconciliationData;

    // ---- Structure ----
    this.parent.append(this.div_select);
      this.div_select.append(this.div_from);
        this.div_from.append(this.label_from);
        this.div_from.append(this.input_from);
      this.div_select.append(this.div_to);
        this.div_to.append(this.label_to);
        this.div_to.append(this.input_to);
      this.div_select.append(this.a_excel);
    this.parent.append(this.div_error);
    this.parent.append(this.div_fees);
    this.parent.append(this.p_empty);
    this.parent.append(this.div_table);
      this.div_table.append(this.table);
        this.table.append(this.thead);
        this.table.append(this.tbody);
    this.parent.append(this.h2_sums);
    this.parent.append(this.div_sums);
      this.div_sums.append(this.table_sums);
        this.table_sums.append(this.thead_sums);
        this.table_sums.append(this.tbody_sums);

    // ---- Init ----
    this.div_select.classList.add('c-selection');
    this.p_empty   .classList.add('c-empty');
    this.div_table .classList.add('c-table');
    this.div_sums  .classList.add('c-table');
    this.table_sums.classList.add('c-sums');

    this.label_from.innerText = 'Von';
    this.label_to  .innerText = 'Bis';
    this.dateInput(this.input_from, this.label_from, 'c-reconciliation-from', this.data.from);
    this.dateInput(this.input_to  , this.label_to  , 'c-reconciliation-to'  , this.data.to);

    // The period the page shows, not what the fields hold: a changed date reloads the page anyway.
    const excelParams = new URLSearchParams({from: this.data.from, to: this.data.to});
    this.a_excel.classList.add('button', 'c-excel');
    this.a_excel.innerText = 'Excel herunterladen';
    this.a_excel.href      = '/c-reconciliation-excel?' + excelParams.toString();

    this.h2_sums.innerText = 'Summen';

    this.notice(this.div_error, 'notice-error'  , this.data.error);
    this.notice(this.div_fees , 'notice-warning', this.data.feeError);

    // Without an answer from wallee there is neither a table nor the message of an empty period.
    const showTable = this.data.error === '' && this.data.rows.length > 0;
    const showEmpty = this.data.error === '' && this.data.rows.length === 0;

    this.p_empty.innerText = 'Keine Einzüge oder Rückerstattungen im gewählten Zeitraum.';
    if (!showEmpty) this.p_empty.style.display = 'none';

    if (showTable) {
      this.header();
      for (const row of this.data.rows) this.row(row);
      this.sumHeader();
      this.sums();
    }
    else {
      for (const elm of [this.a_excel, this.div_table, this.h2_sums, this.div_sums]) elm.style.display = 'none';
    }

    // ---- Events ----
    for (const input of [this.input_from, this.input_to]) {
      input.addEventListener('change', () => this.reload());
    }
  }

  dateInput(input: HTMLInputElement, label: HTMLLabelElement, id: string, value: string): void {
    input.type  = 'date';
    input.value = value;
    input.id    = id;
    label.setAttribute('for', id);
  }

  // "notice inline" is the wp-admin notice, inline keeps wp-admin from moving it below the h1.
  notice(div: HTMLDivElement, css: string, text: string): void {
    if (text === '') {
      div.style.display = 'none';
      return;
    }
    const p = document.createElement('p');
    p.innerText = text;
    div.classList.add('notice', css, 'inline');
    div.append(p);
  }

  header(): void {
    const tr = document.createElement('tr');
    for (const text of ['Zeit', 'Typ', 'Bestellung', 'Kunden-Nr.', 'Name', 'Zahlart', 'Status WooCommerce', 'Status wallee']) {
      this.th(tr, text, false);
    }
    this.amountHeads(tr);
    this.th(tr, 'Hinweis', false);
    this.thead.append(tr);
  }

  sumHeader(): void {
    const tr = document.createElement('tr');
    this.th(tr, 'Zahlart', false);
    this.th(tr, ''       , false);
    this.amountHeads(tr);
    this.thead_sums.append(tr);
  }

  // The same amount columns in both tables.
  amountHeads(tr: HTMLTableRowElement): void {
    for (const text of ['Total', 'Gebühren', 'Gutschrift']) this.th(tr, text, true);
  }

  row(row: ReconciliationRow): void {
    const tr = document.createElement('tr');
    // A manual refund did not go through wallee, a failed capture or refund moved no money. Neither
    // is in the sums of the payment methods.
    if (row.type === 'manual') tr.classList.add('c-manual');
    else if (!row.counted)     tr.classList.add('c-not-counted');

    this.td(tr, row.timeLabel);
    this.td(tr, TYPE_LABELS[row.type]);
    this.link(tr, row.orderLabel, row.orderUrl, false);
    this.td(tr, row.customerId);
    this.td(tr, row.customerName).classList.add('c-name');
    this.td(tr, row.paymentMethod);
    this.td(tr, row.wcStatus);
    this.link(tr, row.walleeState, row.walleeUrl, true);
    this.amount(tr, row.total);
    this.fee(tr, row.fees  , row.feeState);
    this.fee(tr, row.credit, row.feeState);

    const td_hints = this.td(tr, '');
    td_hints.classList.add('c-hints');
    for (const hint of row.hints) {
      const div = document.createElement('div');
      div.innerText = hint;
      td_hints.append(div);
    }

    this.tbody.append(tr);
  }

  // The payment method only on the first line of its group.
  sums(): void {
    let method = '';
    for (const sum of this.data.sums) {
      const tr = document.createElement('tr');
      if (sum.paymentMethod !== method) tr.classList.add('c-group-start');
      if (sum.label === 'Total')        tr.classList.add('c-total');

      this.td(tr, sum.paymentMethod !== method ? sum.paymentMethod : '');
      this.td(tr, sum.label);
      this.amount(tr, sum.total);
      this.fee(tr, sum.fees  , sum.feeState);
      this.fee(tr, sum.credit, sum.feeState);

      method = sum.paymentMethod;
      this.tbody_sums.append(tr);
    }
  }

  th(tr: HTMLTableRowElement, text: string, isAmount: boolean): void {
    const th = document.createElement('th');
    th.innerText = text;
    if (isAmount) th.classList.add('c-amount');
    tr.append(th);
  }

  td(tr: HTMLTableRowElement, text: string): HTMLTableCellElement {
    const td = document.createElement('td');
    td.innerText = text;
    tr.append(td);
    return td;
  }

  // The order in the same tab like any link of wp-admin, wallee in a new one.
  link(tr: HTMLTableRowElement, text: string, href: string, external: boolean): void {
    const td = this.td(tr, '');
    if (href === '') {
      td.innerText = text;
      return;
    }
    const a = document.createElement('a');
    a.href      = href;
    a.innerText = text;
    if (external) {
      a.target = '_blank';
      a.rel    = 'noopener';
    }
    td.append(a);
  }

  amount(tr: HTMLTableRowElement, value: number | null): void {
    const td = this.td(tr, value === null ? '' : value.toFixed(2));
    td.classList.add('c-amount');
  }

  // Fees and credit only exist once wallee has booked the capture or refund. Until then "offen",
  // while the booking is still upcoming the amount with "vorläufig".
  fee(tr: HTMLTableRowElement, value: number | null, state: ReconciliationFeeState): void {
    const td = this.td(tr, '');
    td.classList.add('c-amount');
    if (state === '') return;

    if (value !== null) td.append(value.toFixed(2));
    const label = FEE_STATE_LABELS[state];
    if (label === '') return;

    const span = document.createElement('span');
    span.classList.add('c-fee-state');
    span.innerText = label;
    td.append(span);
  }

  reload(): void {
    if (this.input_from.value === '' || this.input_to.value === '') return;
    const urlParams = new URLSearchParams();
    urlParams.set('page', 'abrechnung');
    urlParams.set('from', this.input_from.value);
    urlParams.set('to'  , this.input_to.value);
    window.location.href = '/wp-admin/admin.php?' + urlParams.toString();
  }
}
